import { ROUTES } from './aiActions';

// Keyword-only fallback used when the real (Gemini) AI is unreachable —
// no model call, just enough pattern matching to still execute the
// handful of deterministic actions (navigate, toggle theme, open logs)
// that don't actually require language understanding.

const CREATABLE_ENTITIES = ['promo_codes', 'fare_config', 'document_types'];

const LOG_KEYWORDS = [
  'server log', 'server logs', 'backend log', 'backend logs',
  'error log', 'error logs', 'debug log', 'debug logs',
  'log viewer', 'logs viewer', 'view logs', 'show logs', 'open logs',
];

const APP_CONFIG_KEYWORDS = [
  'app config', 'app configuration', 'maintenance mode', 'force update',
];

const THEME_KEYWORDS = ['dark mode', 'light mode', 'toggle theme', 'switch theme', 'change theme'];

const PAGE_KEYWORDS = {
  dashboard: ['dashboard', 'home page'],
  users: ['users', 'riders'],
  drivers: ['drivers'],
  rides: ['rides', 'trips'],
  payments: ['payments', 'transactions'],
  promo_codes: ['promo codes', 'promo code', 'coupons', 'promocodes'],
  fare_config: ['fare config', 'fare configuration', 'pricing'],
  support: ['support tickets', 'support', 'tickets'],
  offers: ['offers'],
  document_types: ['document types', 'documents'],
  notifications: ['notifications'],
  settings: ['settings'],
};

const CREATE_INTENT = /\b(create|add|new)\b/;

/** Returns { name, args } (same shape `dispatchAction` expects) or null if
 * nothing in the offline rule set matches. */
export function matchOfflineIntent(rawText) {
  const text = rawText.toLowerCase().trim();
  if (!text) return null;

  if (LOG_KEYWORDS.some((k) => text.includes(k)) || /\blogs\b/.test(text)) {
    return { name: 'open_server_logs', args: {} };
  }

  if (APP_CONFIG_KEYWORDS.some((k) => text.includes(k))) {
    return { name: 'open_app_config', args: {} };
  }

  if (THEME_KEYWORDS.some((k) => text.includes(k))) {
    return { name: 'toggle_theme', args: {} };
  }

  const wantsCreate = CREATE_INTENT.test(text);
  for (const page of Object.keys(ROUTES)) {
    const keywords = PAGE_KEYWORDS[page] ?? [];
    if (keywords.some((k) => text.includes(k))) {
      if (wantsCreate && CREATABLE_ENTITIES.includes(page)) {
        return { name: 'open_create_modal', args: { entity: page } };
      }
      return { name: 'navigate_to_page', args: { page } };
    }
  }

  return null;
}
